import React, {Component} from 'react';
import './index.scss';
import {logPageView} from 'services/analytics';
import RouteURLs from 'RouteURLs';
import DefaultLayout from 'layouts/Default';
import Banner from "../../components/banner";

export default class NotFoundPage extends Component {
  componentDidMount(): void {
    logPageView(RouteURLs.NOT_FOUND, 'Not Found');
  }

  render() {
    return (
      <DefaultLayout id="not-found-page">
          <Banner />
      </DefaultLayout>
    );
  }
}
